/*=========================================================================================
  File Name: moduleSuspectGetters.js
  Description: Suspect Module Getters
  ----------------------------------------------------------------------------------------
==========================================================================================*/


export default {

}